import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import CloseButton from '../close-button/close-button.jsx';
import styles from './sprite-selector-item.css';
import iconFont from '../../css/iconfont.css';
import hideHandlerImg from './hide.png';
import showHandlerImg from './show.png';
import {ContextMenuTrigger} from 'react-contextmenu';
import {ContextMenu, MenuItem} from '../context-menu/context-menu.jsx';
import {FormattedMessage} from 'react-intl';
import {isTeacherMode} from '../../lib/hetao-mode';

import SpriteItemSelectorInput from '../../containers/sprite-selector-item-input.jsx';

// react-contextmenu requires unique id to match trigger and context menu
let contextMenuId = 0;

import lockIcon from './icon--lock.svg';
import nolockIcon from './icon--nolock.svg';

const teacherMode = isTeacherMode();

const DisplayHandler = (props) => {
    if (!teacherMode) {
        return null;
    }
    return <img src={props.show ? hideHandlerImg : showHandlerImg} width={15} onClick={() => props.onHandleDisplaySprite(props.show)} />
}

const SpriteSelectorItem = props => (
    <ContextMenuTrigger
        attributes={{
            className: classNames(props.className, styles.spriteSelectorItem, {
                [styles.isSelected]: props.selected
            }),
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            onMouseDown: props.editMode ? '' : props.onMouseDown,
            onTouchStart: props.onMouseDown
        }}
        disable={props.dragging}
        id={`${props.name}-${contextMenuId}`}
    >
        {(props.isSprite && props.selected && teacherMode) ? (
            <div className={styles.lockButton}>
                {props.disabled ?
                    <div
                        className={styles.iconWrapper}
                        onClick={props.onClickNotLock}
                    >
                        <img
                            className={styles.icon}
                            src={lockIcon}
                        />
                    </div> : <div
                        className={styles.iconWrapper}
                        onClick={props.onClickLock}
                    >
                        <img
                            className={styles.icon}
                            src={nolockIcon}
                        />
                    </div>
                }
            </div>
        ) : null }
        {((props.isStage || props.isSprite) && props.selected) ? (
            <CloseButton
                buttonType={'config'}
                className={styles.configButton}
                size={CloseButton.SIZE_SMALL}
                onClick={props.onConfigButtonClick}
            />
        ) : null }
        {(props.isSprite && props.selected && props.onDeleteButtonClick && !props.disabled) ? (
            <CloseButton
                className={styles.deleteButton}
                size={CloseButton.SIZE_SMALL}
                onClick={props.onDeleteButtonClick}
            />
        ) : null }
        {typeof props.number === 'undefined' ? null : (
            <div className={styles.number}>{props.number}</div>
        )}
        {props.costumeURL ? (
            <img
                className={styles.spriteImage}
                src={props.costumeURL}
            />
        ) : null}
        <div className={styles.spriteInfo}>
            <div className={styles.spriteName}>
                {!props.isSprite && (<div className={styles.text}>
                    <span className={styles.displayText}>{props.name}</span>
                </div>)
                }
                {props.isSprite && props.editMode &&
                    (

                        <span className={styles.inputBox}>
                            <SpriteItemSelectorInput
                                small
                                type="text"
                                value={props.name}
                                onExitEditMode={props.onExitEditMode}
                                onSubmit={props.onChangeName}

                            /></span>

                    )
                }
                {props.isSprite && !props.editMode && (<React.Fragment>
                    <div className={styles.text}>
                        <span className={styles.displayText}>{props.name}</span>
                    </div>
                    <span className={styles.icon}>
                        {props.disabled ? <DisplayHandler onHandleDisplaySprite={props.onHandleDisplaySprite} show={props.show} /> :
                                <i
                                    className={classNames(iconFont.iconfont, iconFont.iconShuru)}
                                    onClick={props.onIntoEditMode}
                                />
                        }
                    </span>
                </React.Fragment>)}
            </div>
            {props.details ? (
                <div className={styles.spriteDetails}>{props.details}</div>
            ) : null}
        </div>
        {props.isSprite && (props.onDuplicateButtonClick || props.onDeleteButtonClick || props.onExportButtonClick) ? (
            <ContextMenu id={`${props.name}-${contextMenuId++}`}>
                {props.onDuplicateButtonClick ? (
                    <MenuItem onClick={props.onDuplicateButtonClick}>
                        <FormattedMessage
                            defaultMessage="duplicate"
                            description="Menu item to duplicate in the right click menu"
                            id="gui.spriteSelectorItem.contextMenuDuplicate"
                        />
                    </MenuItem>
                ) : null}
                {props.onDeleteButtonClick ? (
                    <MenuItem onClick={props.onDeleteButtonClick}>
                        <FormattedMessage
                            defaultMessage="delete"
                            description="Menu item to delete in the right click menu"
                            id="gui.spriteSelectorItem.contextMenuDelete"
                        />
                    </MenuItem>
                ) : null }
                {props.onExportButtonClick ? (
                    <MenuItem onClick={props.onExportButtonClick}>
                        <FormattedMessage
                            defaultMessage="export"
                            description="Menu item to export the selected item"
                            id="gui.spriteSelectorItem.contextMenuExport"
                        />
                    </MenuItem>
                ) : null }
            </ContextMenu>
        ) : null}
    </ContextMenuTrigger>
);

SpriteSelectorItem.propTypes = {
    className: PropTypes.string,
    costumeURL: PropTypes.string,
    details: PropTypes.string,
    disabled: PropTypes.bool,
    dragging: PropTypes.bool,
    editMode: PropTypes.bool,
    isSprite: PropTypes.bool,
    isStage: PropTypes.bool,
    name: PropTypes.string.isRequired,
    number: PropTypes.number,
    onChangeName: PropTypes.func,
    onClick: PropTypes.func,
    onClickLock: PropTypes.func,
    onClickNotLock: PropTypes.func,
    onConfigButtonClick: PropTypes.func,
    onDeleteButtonClick: PropTypes.func,
    onDuplicateButtonClick: PropTypes.func,
    onExitEditMode: PropTypes.func,
    onExportButtonClick: PropTypes.func,
    onIntoEditMode: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    selected: PropTypes.bool.isRequired
};

export default SpriteSelectorItem;
